import * as React from 'react';
import TransactionHeader from '~/apps/receiver/mobile/components/transactions/TransactionHeader';

export default function (props) {
  const handleBack = (e) => {
    e.preventDefault();
    if (props.onBack) props.onBack()
  };

  const handleHelp = (e) => {
    e.preventDefault();
    if (props.onHelp) props.onHelp()
  };

  return (
    <React.Fragment>
      <TransactionHeader
        onBack={handleBack}
        onHelp={handleHelp}
        title="New Payment"
      />
      <div className="m__body app--md__box">
        <div className="m__body__i lg"><span className="i i-truck" /></div>
        <div className="m__body__titl--lg">Good to go!</div>
      </div>
    </React.Fragment>
  );
};
